module.exports = __webpack_public_path__ + "static/media/russian.ec68aa44.svg";